<template>
  <div id="detail">
    <header class="header_imgs">一分钟爱上原子币</header>
    <div class="detail-content">
      <!-- <h1 class="details-title">小原子也可以点亮世界</h1> -->
      <div class="contents">
        <ul>
          <li v-for="(item,index) in detailsContent" :key="index">
            <h4 v-if="item.titles">{{item.titles}}</h4>
            <p>{{item.contents}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "details",
  data() {
    return {
      detailsContent: [
        {
          titles: "",
          contents:
            "基于原子链（ATOSHI）发行的原子币（ATOS），定位是国与国之间交易往来的加密货币，其理论依据是，诺贝尔经济学奖获得者哈耶克的《货币的非国家化》。我们认为每个国家拥有自己的铸币权这是神圣不可侵犯的，这样国家可以更好的调动经济资源，建设国家。但是国与国之间的往来交易使用的货币，不应该由某一个国家来发行，而是应该由去中心化的区块链网络发行，由世界人民自己控制。将来加密货币将可能成为国与国之间的外汇储备和结算的货币，原子币就是在这个大背景下孕育而生的。"
        },
        // {
        //   titles: "",
        //   contents:
        //     "原子链技术上将有新的突破。比特币矿池占有超过51%的算力，可以对比特网络全网攻击，所以比特币很难成为一个国家的外汇储备。而原子链采用的更去中心化的POD算法，所谓POD算法是我们原子链首先命名的算法，这个算法在IOTA（前10名的加密货币）上面有实现，但是没有正式命名，即是Power Of Device的简称。交易0手续费，但是交易前需要帮整个网络处理两笔交易。这样我们用的人越多，算力越多，转账速度会越快。每个用户都是一个节点，这样我们的TPS是没有上限的，远超比特币只有7TPS,以太坊只有15TPS，以及EOS的“百万”TPS…而且0手续费，不需要挖矿。矿池都没有，何必有矿池控制全网算力的51%的烦恼？永远都是高度去中心化。"
        // },
        // {
        //   titles: "",
        //   contents:
        //     "原子链技术上将有新的突破。比特币矿池占有超过51%的算力，可以对比特网络全网攻击，所以比特币很难成为一个国家的外汇储备。而原子链采用的更去中心化的POD算法，所谓POD算法是我们原子链首先命名的算法，这个算法在IOTA（前10名的加密货币）上面有实现，但是没有正式命名，即是Power Of Device的简称。交易0手续费，但是交易前需要帮整个网络处理两笔交易。这样我们用的人越多，算力越多，转账速度会越快。每个用户都是一个节点，这样我们的TPS是没有上限的，远超比特币只有7TPS,以太坊只有15TPS，以及EOS的“百万”TPS…而且0手续费，不需要挖矿。矿池都没有，何必有矿池控制全网算力的51%的烦恼？永远都是高度去中心化。"
        // },
        // {
        //   titles: "",
        //   contents:
        //     "原子链将采用实名制。以后大家不用担心丢失钱包密码，通过验证身份，指纹，刷脸验证，丢了密码，丢了手机也可以高枕无忧找回来。各个国家也不用担心犯罪份子通过原子链网络做不法交易，符合各国监管，更利于社会安全和稳定。另外原子链将打造成区块链中的底层操作系统，也就是说可以在原子链的上开发各种Dapp,而且用户界面非常友好，简单易用，点击菜单即可。这样的话，各个行业都可以在我们的原子链上开发自己的链，跟原子链是并行链，没有谁是主链谁是侧链，大家平等。各条链之间又可以跨链用原子币ATOS进行价值支付。同时还有跨链去中心化钱包，支持指纹刷脸识别。各个行业都可以加入原子链打造的去中心化操作系统, 这样我们的原子币ATOS基本应用场景会非常广阔，变成世界的硬通货。最终为国际认可，形成一种国家之间可以自由使用秒级到账，不可增发的优势货币。世界人民已经感觉到美元不断增发剪各国羊毛的烦恼，良币驱逐，世界人民最终会做出抛弃美金决定。从此国际支付就用加密货币，原子币很有可能成为幸运儿。"
        // },
        // {
        //   titles: "",
        //   contents:
        //     "据有关数据统计，国与国之间使用的货币和外汇储备，规模超200万亿美金。原子币定位就是这种加密货币之一。如果我们占到市场1%，那么我们的市值将是2万亿美元，将成为世界上市值最大的公司，原子链将为原子币的发展提供区块链基础平台。原子链将具有以下魔法特点："
        // },
          {
            titles: "",
            contents:
              "原子链将以下魔法特点作为奋斗目标："
          },
        {
          titles: "1.理想很丰满。原子链，爱国链。",
          contents:
            "我们用区块链去中心化实现布雷顿森林体系当年的愿景。加密货币的产生将让任何一个国家收其他国家的铸币税成为历史，让国家和国家之间更加平等。"
        },
        {
          titles: "",
          contents:
            "区块链是通向未来的技术，比特币启蒙下的一系列加密货币，可以重塑世界金融格局，提高国际支付生产效率，减低支付成本，让各国人民更加平等的参与世界金融，进而可能让各国经济实力大洗牌。我国凭借强大的实体经济，加上更加平等的国际金融环境，在一定程度上有助于大国崛起。我们将用区块链给产业赋能，助力大国崛起。"
        },
        {
          titles: "2.现实很骨感。原子链，实干链。",
          contents:
            "原子链要实现的技术愿景是：交易速度快，低交易费用，实名制，配合各国监管，数量有限，分布式记账。"
        },
        {
          titles: "",
          contents:
            "就像当年手机有诺基亚有摩托罗拉一样，乔布斯觉得应该有个更好的手机叫iphone。我们也认为比特币是10多年前发明的，10年后肯定有更好的技术可以超越他。有很多数字货币都很优秀，但是缺乏一款数字货币中的 “苹果手机” ，这就是我们奋斗的方向。"
        },
        {
          titles: "",
          contents:
            "我们踏实用区块链去解决现在黄金，比特币还有其他加密货币的痛点，一个个问题去踏实解决，让用户更方便、更好用。"
        },
        {
          titles: "",
          contents:
            "比特币tps只有7，以太坊tps只有15，网路经常拥堵......加密货币发展尚处于早期，实干的我们一起引导这个新行业给世界赋能。"
        },
        // {
        //   titles: "",
        //   contents:
        //     "目前，国际转账至少要3天，且手续费昂贵。如果在国外发生车祸，立即要做手术，生命垂危，否则错过抢救时间。手术的巨款需要国际转账，生命就会因此凋零。我们一起贡献一份力量！ATOS转账可以秒到，无论你在地球任何一个角落。不用出门，零成本立即到账。"
        // },
        {
          titles: "3.定位大格局。原子链，格局链。",
          contents:
            "ATOS定位为国与国之间支付的加密货币，我们用区块链技术去实现布雷顿森林体系的美好愿景，也就是一种相对公平易用的国际通用货币。"
        },
          {
              titles: "",
              contents:
                  "国与国之间通用的货币和外汇储备，规模超200万亿美金。如果我们占到市场1%，那么我们的市值将是2万亿美元，将成为世界上市值最大的公司。"
          },
          {
              titles: "",
              contents:
                  "原子币定位就是这种大格局的加密货币。"
          },
        {
          titles: "4.团队有信仰。原子链，信仰链。",
          contents: ""
          // contents:
          //   "创始团队通证也锁仓3年不能交易，三年之后只能每年释放团队份额的20%，释放完全需要8年。原子基金会锁仓每年释放不得超过其份额10%，至少10年才能释放完。"
        },
        {
          titles: "",
          contents:
            "我们认为解决社会痛点，实现让社会更美好的理想是第一的。我们用钢铁的意志去努力，我们吸引最优秀的人才加入我们IMFO，一起推动区块链行业正向发展。我们做好精神文明建设的同时，也注重所有成员的物质文明，一起让世界更美好的同时让自己更美好。"
        },
        {
          titles: "5.价值超靠谱。原子链，价值链。",
          contents:
            "原子链项目的收入部分用来回购原子币，还有部分将投资各种公司，要求他们在条件成熟的时候接受原子币进行支付。这样我们将持有很多高增长公司的股份，变成一个巨无霸区块链投行。"
        },
          {
              titles: "",
              contents:
                  "腾讯之所以强大，离不开他投资了很多公司。我们投资的公司都将使用原子币作为支付手段，而且是打折支付，就形成了一个多行业的广泛应用原子币的场景，成为一种不可增发的秒级到账的优势货币。"
          },
          {
              titles: "",
              contents:
                  "比特币，以太坊，瑞波币等都没有实体资产支撑，不够“硬“，我们原子币将“硬”气到底。比特币增值了2600万倍，原子币站在这些巨人的肩膀上进行更好的创新，青出于蓝，发展潜力巨大。"
          },
        {
          titles: "结束语：",
          contents:
            "原子链的愿景是站在比特币巨人的肩膀上，进行一定的创新和改进。跟黄金还有比特币一样，这些产品的优点我们都要有，但他们的缺点我们将进行改进。"
        },
        {
          titles: "",
          contents:
            "目前，国际转账至少要3天，且手续费昂贵。如果在国外发生车祸，立即要做手术，生命垂危，否则错过抢救时间。手术的巨款需要国际转账，生命就会因此凋零。我们一起贡献一份力量！ATOS转账可以秒级到账，无论你在地球任何一个角落。不用出门，低成本立即到账。"
        },
          {
              titles: "",
              contents:
                  "区块链是通向未来的技术。IMFO及原子链用区块链可以更加公平高效，降低成本。区块链正在改变世界，小原子也可以点亮世界。"
          },
      ]
    };
  }
};
</script>

<style scoped>
.header_imgs {
  background: url('../assets/sjasyzb.png') no-repeat
    center center;
  background-size: cover;
  width: 100%;
  font-size: 0.42rem;
  text-align: center;
  line-height: 1.2rem;
  color: #fff;
}
.detail-content {
  background-color: #f5f5f5;
  color: #222;
}
.details-title {
  width: 90%;
  margin: 0 auto;
  padding: 0.5rem 0;
  font-size: 0.32rem;
  text-align: center;
}
.contents h4 {
  box-sizing: border-box;
  padding: 0.3rem 0.4rem;
  width: 100%;
  background-color: #fff;
}
.contents p {
  box-sizing: border-box;
  padding: 0.2rem 0.4rem;
  line-height: 0.5rem;
}
li:nth-last-of-type(1) {
  padding-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/Details.vue